// @packages
import Toast from 'react-native-root-toast';
import { Durations } from '../../utils/types';

/**
 * @return {Object}
*/
const globalUI = {
  /**
     * @param {string} message
     * @param {number} duration
     * @param {Object} options
     * @return {Object}
     * @memberof globalUI
     * @description Show a toast message
     * @example
     * globalUI.showToast('Hello world', Durations.SHORT, {
     *  animation: true,
     *  delay: 0,
     *  hideOnPress: true,
     *  position: Toast.positions.BOTTOM,
     *  shadow: true,
     * });
     *
    */
  showToast(message: string, duration: Durations, options?: Record<string, unknown>) {
    return Toast.show(message, {
      duration: Toast.durations[duration],
      ...options
    });
  }
};

export default globalUI;
